module.exports = __webpack_public_path__ + "static/media/FVS-Logo.c96aa32b.png";